import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { DebtStateResponse } from "../../models/debt-states.model";
import { DebtActions } from "./debt.actions";
import { DebtService } from "../../services/debt.service";
import { DebtYearResponse } from "../../models/debt-year.model";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";

export class DebtStateModel {
    public debtStates: DebtStateResponse[];
    public debtYears: DebtYearResponse[];
    public error: string;
  }

  const defaults = {
    debtStates: [],
    debtYears: [],
    error: '',
  };

  @State<DebtStateModel>({
    name: 'debt',
    defaults,
  })
  @Injectable()
  export class DebtState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      public store: Store,
      private debtService: DebtService,
    ) {}

    @Action(DebtActions.GetDebtStates) getDebtStates(
      ctx: StateContext<DebtStateModel>,
      {}: DebtActions.GetDebtStates
    ) {
      return this.debtService
        .getDebtStates()
        .subscribe({
          next: (response) =>
            ctx.dispatch(new DebtActions.GetDebtStatesSuccess(response)),
          error: (error) =>
            ctx.dispatch(new DebtActions.Error(error)),
        });
    }

    @Action(DebtActions.GetDebtStatesSuccess)
    getDebtStatesSuccess(ctx: StateContext<DebtStateModel>,
      { debtStates }: DebtActions.GetDebtStatesSuccess
    ) {
      ctx.patchState({
        debtStates: debtStates.sort((a, b) => a.debtStateId - b.debtStateId)
      });
    }

    @Action(DebtActions.GetDebtYears) getDebtYears(
      ctx: StateContext<DebtStateModel>,
      {}: DebtActions.GetDebtYears
    ) {
      return this.debtService
        .getDebtYears()
        .subscribe({
          next: (response) =>
            ctx.dispatch(new DebtActions.GetDebtYearsSuccess(response)),
          error: (error) =>
            ctx.dispatch(new DebtActions.Error(error)),
        });
    }

    @Action(DebtActions.GetDebtYearsSuccess)
    getDebtYearsSuccess(ctx: StateContext<DebtStateModel>,
      { debtYears }: DebtActions.GetDebtYearsSuccess
    ) {
      ctx.patchState({
        debtYears: debtYears.sort((a, b) => a.debtYearId - b.debtYearId)
      });
    }

    @Action(DebtActions.Error)
    onErrorOcurred(
      ctx: StateContext<DebtStateModel>,
      { error }: DebtActions.Error
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('labels.debt');
    }
  }
